import { useCallback, useEffect, useState } from 'react';
import technicianService from '../../api/technicianService';
import { useNotifications } from '../../context/NotificationContext';
import StarRating from '../common/StarRating';
import Pagination from '../common/Pagination';
import LoadingSpinner from '../common/LoadingSpinner';
import EmptyState from '../common/EmptyState';
import { dateOnly } from '../../utils/formatters';

export default function Reviews() {
  const notify = useNotifications();
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [], totalPages: 0 });
  const [loading, setLoading] = useState(true);
  const [replyFor, setReplyFor] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    technicianService.listReviews({ page, size: 10 })
      .then(setData)
      .catch((e) => notify.apiError(e))
      .finally(() => setLoading(false));
  }, [page, notify]);

  useEffect(() => { load(); }, [load]);

  const sendReply = async (id) => {
    setBusy(true);
    try {
      await technicianService.replyToReview(id, text);
      notify.success('Reply posted');
      setReplyFor(null); setText('');
      load();
    } catch (e) {
      notify.apiError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page">
      <div className="container stack" style={{ gap: '1.25rem', maxWidth: 760 }}>
        <h1>Reviews</h1>
        {loading ? (
          <LoadingSpinner />
        ) : data.content.length === 0 ? (
          <EmptyState icon="star" title="No reviews yet" />
        ) : (
          <div className="stack">
            {data.content.map((r) => (
              <div key={r.id} className="card pad stack" style={{ gap: '.4rem' }}>
                <div className="spread">
                  <strong>{r.clientName || 'Client'}</strong>
                  <span className="muted" style={{ fontSize: '.85rem' }}>{dateOnly(r.createdAt)}</span>
                </div>
                <StarRating value={r.rating} />
                {r.comment && <p>{r.comment}</p>}
                {r.response ? (
                  <p className="muted" style={{ fontSize: '.9rem' }}><i className="bi bi-reply" /> {r.response}</p>
                ) : replyFor === r.id ? (
                  <div className="stack" style={{ gap: '.4rem' }}>
                    <textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={2000}
                      style={{ border: '1px solid var(--line)', borderRadius: 'var(--radius-sm)', padding: '.5rem' }} />
                    <div className="row" style={{ gap: '.5rem' }}>
                      <button className="btn sm" disabled={busy || !text.trim()} onClick={() => sendReply(r.id)}>Post reply</button>
                      <button className="btn ghost sm" onClick={() => { setReplyFor(null); setText(''); }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <button className="btn ghost sm" style={{ alignSelf: 'flex-start' }} onClick={() => { setReplyFor(r.id); setText(''); }}>
                    Reply
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
        <Pagination page={page} totalPages={data.totalPages} onChange={setPage} />
      </div>
    </div>
  );
}
